import {
  Box,
  Button,
  CircularProgress,
  Grid,
  InputLabel,
  makeStyles,
  TextField
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { green } from '@material-ui/core/colors';
import { Formik } from 'formik';
import { STATUS_API } from 'src/app/constant/config';
import { getListAgencies } from 'src/features/agencySlice';
import { updateDeviceTransfer } from 'src/features/deviceSlice';
import * as Yup from 'yup';
import CustomDialog from 'src/app/components/CustomDialog';

const TransferDevice = ({ open, onClose, rowsSelected }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const statusTransfer = useSelector(state => state.agencySlice.statusTransfer);
  const listAgencies = useSelector(state => state.agencySlice.listAgencies);
  const isAdmin = useSelector(state => state.authSlice.isAdmin);
  const isAccountant = useSelector(state => state.authSlice.isAccountant);
  const isSale = useSelector(state => state.authSlice.isSale);
  const isLeadMarketing = useSelector(state => state.authSlice.isLeadMarketing);

  useEffect(() => {
    if (isAdmin || isAccountant || isSale || isLeadMarketing) dispatch(getListAgencies({ page_size: 1000 }));
  }, [isAdmin, isAccountant, isSale, isLeadMarketing]);

  const handleSubmit = (data) => {
    if (data.agency_id) {
      dispatch(
        updateDeviceTransfer({
          agency_id: Number(data.agency_id),
          list_device_id: rowsSelected
        })
      );
    }
    onClose();
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <CustomDialog title="Chuyển kho thiết bị" open={open} onClose={handleClose} sizeSmall={true}>
      <div>
        <Formik
          initialValues={{ agency_id: '' }}
          enableReinitialize={true}
          validationSchema={Yup.object().shape({
            agency_id: Yup.number()
              .required('Tên đại lý không được để trống'),
          })}
          onSubmit={handleSubmit}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            touched,
            values,
            setFieldValue
          }) => (
            <form onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                <Grid item md={12} xs={12}>
                  <InputLabel style={{ marginBottom: "21px" }}>
                    Chọn đại lý <span className="text-danger"></span>
                  </InputLabel>
                  <Autocomplete
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    size="small"
                    options={listAgencies || []}
                    getOptionLabel={option => option.name}
                    value={(listAgencies || []).find(
                      option => option.id === values.agency_id
                    )}
                    onChange={(e, value) => setFieldValue('agency_id', value.id)}
                    disableClearable
                    renderInput={params => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Chọn đại lý"
                        name="agency_id"
                        error={Boolean(
                        touched.agency_id && errors.agency_id
                        )}
                        helperText={touched.agency_id && errors.agency_id}
                        InputProps={{
                          ...params.InputProps,
                          style: {
                            fontSize: '16px',
                            padding: '0 8px',
                            height: '35px',
                          }
                        }}
                      />
                    )}
                    className={classes.customOutline}
                  />
                </Grid>
              </Grid>
              <Box my={3}>
                <Box
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginTop: '15px',
                    '& .left-button': {
                      display: 'flex'
                    }
                  }}
                >
                  <Button
                    style={{
                      marginRight: '10px',
                      textTranform: 'none !important'
                    }}
                    onClick={() => onClose()}
                    className="btn-main btn-plain mx-3"
                    color="primary"
                    size="large"
                    variant="contained"
                  >
                    Thoát
                  </Button>
                  <Button
                    style={{
                      marginRight: '10px',
                      textTranform: 'none !important'
                    }}
                    className="btn-main mx-3"
                    color="primary"
                    size="large"
                    type="submit"
                    variant="contained"
                  >
                    Chuyển xuống
                  </Button>
                  {statusTransfer === STATUS_API.PENDING && (
                    <CircularProgress
                      size={24}
                      className={classes.buttonProgress}
                    />
                  )}
                </Box>
              </Box>
            </form>
          )}
        </Formik>
      </div>
    </CustomDialog>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  groupButtonSubmit: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '15px',

    '& .left-button': {
      display: 'flex'
    }
  },
  wrapper: {
    position: 'relative'
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  },
  customOutline: {
    '& .MuiOutlinedInput-notchedOutline': {
      borderWidth: '1px',
      borderColor: 'rgba(31, 31, 31, 0.14)',
      borderRadius: '4px'
    },
  }
}));

export default React.memo(TransferDevice);
